import { useTranslation } from 'react-i18next';
import Button from '../../../button/button';

interface ApplyFilterButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

const ApplyFilterButton = ({ onClick, disabled }: ApplyFilterButtonProps) => {
  const { t } = useTranslation();

  return (
    <Button type="primary" fullWidth={false} onClick={onClick} disabled={disabled}>
      {t('apply', 'Apply')}
    </Button>
  );
};

export default ApplyFilterButton;
